import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage, IntlShape } from 'react-intl';
import DefaultButton from '../../../../global/default-button/default-button';
import { DeliveryTeamRole } from '../../../../_events/_events-list/_event-form/delivery-team/delivery-team-role/delivery-team-role';
import Text from '../../../../global/text/text';
import { getFormattedDeliveryMemberRoles } from '../../../../../constants/entity-role-with-intl';
import { IDeliveryItemDetailsDTO } from '../../../../../api/events.dao';
import { REMOVE_TEXT } from '../../../../../constants/common-labels.constants';

export interface IDeliveryTeamListProps {
    removeDeliveryItem: (
        intl: IntlShape,
        deliveryMemberUserName: string,
        deliveryMemberUserId: string,
        eventId: number,
        accountId: number
    ) => Promise<void>;
    setDeliveryMemberRole: (
        intl: IntlShape,
        deliveryMemberUserName: string,
        deliveryMemberUserId: string,
        eventId: number,
        accountId: number,
        role: string
    ) => Promise<void>;
    deliveryTeamItems: IDeliveryItemDetailsDTO[];
    intl: IntlShape;
    eventId: number;
    accountId: number;
    canRenderAddMembersButton: boolean;
}

export const DeliveryTeamList = mobxReact.observer((props: IDeliveryTeamListProps) => {
  const {
      removeDeliveryItem,
      deliveryTeamItems,
      setDeliveryMemberRole,
      intl,
      eventId,
      accountId,
      canRenderAddMembersButton,
  } = props;

  const deliveryMemberRoles = getFormattedDeliveryMemberRoles(intl);

  const deliveryMemberRolesWithUnassigned = [
      {
          id: null,
          label: intl.formatMessage({
              id: 'oe.common.unassigned',
              description: 'Label text',
              defaultMessage: 'Unassigned'
          })
      },
      ...deliveryMemberRoles
  ];

  return (
      <div className='event_form__items-section'>
          <div className='event_form__items-section__title'>
              <FormattedMessage
                  id='oe.common.deliveryTeam'
                  description='Title text'
                  defaultMessage='Delivery Team'
              />
          </div>
          <div className='event_form__items-section__selected-items'>
              {deliveryTeamItems.map(({ username, firstName, lastName, deliveryTeamMemberRole, active }) => (
                  <div
                      key={username}
                      className={'event_form__items-section__item-wrapper'}
                  >
                      <Text
                          className='event_form__items-item-label'
                          message={`${firstName} ${lastName}`}
                          withEllipsis
                      />
                      <DeliveryTeamRole
                          customPopoverWidth={220}
                          customLeft={0}
                          shouldRenderIcon={canRenderAddMembersButton && active}
                          deliveryMemberRole={deliveryTeamMemberRole}
                          deliveryMemberRoles={deliveryMemberRolesWithUnassigned}
                          username={username}
                          setDeliveryMemberRole={(userId: string, role: string) =>
                            setDeliveryMemberRole(
                              intl,
                              `${firstName} ${lastName}`,
                              userId,
                              eventId,
                              accountId,
                              role
                            )
                          }
                          intl={intl}
                      />
                      {canRenderAddMembersButton && <DefaultButton
                          text={<FormattedMessage {...REMOVE_TEXT} />}
                          modifier='remove'
                          onClick={() => removeDeliveryItem(
                            intl,
                            `${firstName} ${lastName}`,
                            username,
                            eventId,
                            accountId
                          )}
                          className='event_form__items-section__remove-item-button'
                      />
                    }
                  </div>
                ))}
          </div>
      </div>
  );
});
